import { Grid } from "@mui/material";
import { DropDown } from "components/UI";
import { FORM_DEFAULT_STOCK_SUMMARY } from "pages/Report/constants/constants";
import React, { useEffect, useState } from "react";
import ButtonAction from "../ButtonAction";
import { useExcelDownloadOnlineMutation, useReportCommonGetRPackageOwnerQuery } from "shared/services/report";

import { responseErrors } from "utils";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { ResponseText } from "utils/5xxResponseText";
import { waitAndDownloadExcel } from "shared/services/common-dowload/download-helper-service";
import { useSelector } from "react-redux";
import { COMMON_ENUM } from "shared/constants";

export default function StockSummaryReport(props) {
  const userInfo = useSelector(state => state.auth.user);
  const [form, setForm] = useState(FORM_DEFAULT_STOCK_SUMMARY);
  const reportTypeList = [
    {
      cd: "L",
      value: "Location",
    },
    {
      cd: "R",
      value: "R-Package Type",
    },
  ];
  const { data: rPkgOwnerList, failureReason: rPkgOwnerFailureReason } = useReportCommonGetRPackageOwnerQuery();

  useEffect(() => {
    let message = [];
    if (rPkgOwnerFailureReason?.response?.status >= 404) {
      message.push(`R-Package Owner List: ${ResponseText[rPkgOwnerFailureReason?.response?.status]}`);
    }

    props.setMsgServerErrorAlert(message);
  }, [rPkgOwnerFailureReason?.response?.status, props]);

  const [disabledSubmitBtn, setDisabledSubmitBtn] = useState(false);
  const generateReport = useExcelDownloadOnlineMutation();
  const { startLoading, stopLoading } = useLoadingContext();
  const handleDownload = async () => {
    try {
      props.setMsgError([]);
      props.setMsgAlert([]);
      const body = {
        userId: userInfo.userName,
        displayName: userInfo.displayName,
        dataOwner: COMMON_ENUM.C_SM_CTG_TMAP_EM,
        rPackageOwner: form?.rPkgTypeOwner,
        reportType: form?.reportType,
      };
      const pathReport = "generate-stock-summary-by-status-report";

      startLoading();
      const response = await generateReport(body, pathReport);
      waitAndDownloadExcel(60, response.data, props.setMsgError, stopLoading);
      setDisabledSubmitBtn(false);

      return;
    } catch (error) {
      const msgError = responseErrors(error);
      props.setMsgError(msgError);
      setDisabledSubmitBtn(false);
      stopLoading();
    }
  };

  useEffect(() => {
    document.getElementById("select-rpackage-owner").focus();
  }, []);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={5} style={{ display: "flex" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*Report : </strong>
          <DropDown
            id="select-report"
            fullWidth
            required
            defaultValue=""
            placeholder="<Select>"
            menu={[{ key: "1", value: "Stock Summary Report by status" }]}
            value={form?.reportId}
            disabled
          />
        </Grid>
        <Grid item xs={7}></Grid>
        <Grid item xs={5} style={{ display: "flex", marginBottom: "15px" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>*R-Package Owner : </strong>
          <DropDown
            id="select-rpackage-owner"
            fullWidth
            required
            value={form?.rPkgTypeOwner}
            defaultValue=""
            placeholder="<Select>"
            // autoFocus={true}
            menu={rPkgOwnerList?.map(val => ({
              key: val.rPkgOwnerCompAbbr,
              value: val.rPkgOwnerCompAbbr,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                rPkgTypeOwner: e.target.value,
              }))
            }
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={5} style={{ display: "flex", marginBottom: "15px" }}>
          <strong style={{ margin: "auto 0px", width: "300px" }}>Report Type :</strong>
          <DropDown
            id="select-report-type"
            fullWidth
            value={form?.reportType}
            defaultValue=""
            placeholder="<All>"
            // autoFocus={true}
            menu={reportTypeList?.map(val => ({
              key: val.cd,
              value: val.value,
            }))}
            onChange={e =>
              setForm(old => ({
                ...old,
                reportType: e.target.value,
              }))
            }
          />
        </Grid>
        <Grid item xs={1}></Grid>
        <ButtonAction
          handleDownload={handleDownload}
          setFrom={setForm}
          defaultFrom={FORM_DEFAULT_STOCK_SUMMARY}
          disabled={disabledSubmitBtn}
          setDisabled={setDisabledSubmitBtn}
          clearMsg={() => {
            props.setMsgAlert([]);
            props.setMsgError([]);
          }}
          firstField={"select-rpackage-owner"}
        />
      </Grid>
    </>
  );
}
